import AdminCard from '@hellodarwin/app-core/lib/components/admin/admin-card';
import { AdminProjectResponse } from '@hellodarwin/core/lib/features/entities/projects-entities';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/index';
import {
  fetchAdmin,
  selectAdminById,
} from '../../../features/api/slices/global-slice';
import {
  selectCompany,
  selectContact,
} from '../../../features/api/slices/profile-slice';
import { useClientApi } from '../../../features/api/use-client-api';
import ProjectSingleHeader from './project-single-header';
import ProjectSingleSection from './project-single-section';
import useProjectBlocks, {
  ProjectSingleSections,
} from './project-single-section/sections';
import { ProjectSingleContent } from './styles';

export interface ProjectSingleProps {
  project: AdminProjectResponse;
  priority?: AdminProjectResponse;
  sections: ProjectSingleSections[];
}

const ProjectSingle: React.FC<ProjectSingleProps> = (props) => {
  const api = useClientApi();
  const dispatch = useAppDispatch();
  const company = useAppSelector(selectCompany);
  const contact = useAppSelector(selectContact);
  const { project, sections } = props;

  const admin = useAppSelector((state) =>
    selectAdminById(state, company?.account_manager ?? ''),
  );

  const blocks = useProjectBlocks({ project });

  useEffect(() => {
    if (!!company?.account_manager) {
      dispatch(fetchAdmin({ api, adminId: company.account_manager }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company?.account_manager]);

  return (
    <ProjectSingleContent>
      <ProjectSingleHeader {...props} />
      {sections
        .filter((s) => !!blocks[s])
        .map((s) => (
          <ProjectSingleSection key={s} {...blocks[s]} />
        ))}
      {!!admin && (
        <AdminCard
          admin={admin}
          company={company}
          contact={contact}
          fullWidth
        />
      )}
    </ProjectSingleContent>
  );
};

export default ProjectSingle;
